import { SUPABASE_URL, SUPABASE_ANON_KEY, isSupabaseConfigured } from "./supabase";
import type { Profile } from "../data/questions";
import type { EmailVariantKey } from "../data/emailVariants";
import type { QuizContext } from "./utm";

export interface SubmitLeadPayload {
  email: string;
  profile: Profile;
  percentage: number;
  optOut: boolean;
  variant: EmailVariantKey;
  answers: number[];
  context: QuizContext;
}

export interface SubmitLeadResponse {
  success: boolean;
  profile?: Profile;
  percentage?: number;
  error?: string;
}

/** POST vers l'Edge Function send-quiz-result. */
export async function submitLead(
  payload: SubmitLeadPayload
): Promise<SubmitLeadResponse> {
  if (!isSupabaseConfigured) {
    // Mode démo / dev sans Supabase : on log et on renvoie success pour ne pas bloquer l'UX.
    console.warn("[submitLead] Supabase non configuré — payload :", payload);
    return { success: true, profile: payload.profile, percentage: payload.percentage };
  }
  const url = `${SUPABASE_URL}/functions/v1/send-quiz-result`;
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        apikey: SUPABASE_ANON_KEY,
      },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const text = await res.text();
      return { success: false, error: text || `HTTP ${res.status}` };
    }
    return (await res.json()) as SubmitLeadResponse;
  } catch (err) {
    return { success: false, error: (err as Error).message };
  }
}
